import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRemoteBenchmarks } from "../../../api";
import { BenchmarkAssetType, useBenchmarks } from "../../../store";
import { translateCategory } from "../../../utils";
import {
  SButton,
  SButtonGroup,
  SGridContainer,
  SLabel,
  SLinearProgress,
} from "./styles";

export const BenchmarksSelector: React.FC = () => {
  const [serverAvaiableBenchmarks, setServerAvaiableBenchmarks] = useState<
    BenchmarkAssetType[]
  >([]);
  const { selectedBenchmarks, addSelectedBenchmark, removeSelectedBenchmark } =
    useBenchmarks();
  const { loading: isBenchmarkFetchLoading, data: benchmarks } =
    useRemoteBenchmarks();
  const { t } = useTranslation();

  useEffect(
    () => setServerAvaiableBenchmarks(benchmarks),
    [benchmarks, setServerAvaiableBenchmarks]
  );

  const generateBenchmarkId = (benchmarkItem: BenchmarkAssetType): string =>
    `${String(benchmarkItem.assetType)}❤❤❤${String(benchmarkItem.identifier)}`;

  const isBenchmarkSelected = useCallback(
    (benchmarkItem): boolean => {
      const benchmarkId = generateBenchmarkId(benchmarkItem);
      const selectedBenchmarksIds = Object.keys(selectedBenchmarks);

      return selectedBenchmarksIds.includes(benchmarkId);
    },
    [selectedBenchmarks]
  );

  const handleSelection = (benchmarkItem: BenchmarkAssetType): void => {
    if (isBenchmarkSelected(benchmarkItem)) {
      removeSelectedBenchmark(generateBenchmarkId(benchmarkItem));
    } else {
      addSelectedBenchmark(benchmarkItem);
    }
  };

  return (
    <SGridContainer>
      <SLabel>{t("benchmarkButton.title")}</SLabel>
      {isBenchmarkFetchLoading ? (
        <SLinearProgress variant="indeterminate" color="inherit" />
      ) : (
        serverAvaiableBenchmarks.length > 1 && (
          <SButtonGroup>
            {serverAvaiableBenchmarks.length > 1 &&
              serverAvaiableBenchmarks.map((benchmarkItem) => (
                <SButton
                  $isSelected={isBenchmarkSelected(benchmarkItem)}
                  key={benchmarkItem.identifier}
                  onClick={() => handleSelection(benchmarkItem)}
                >
                  {translateCategory(benchmarkItem.label)}
                </SButton>
              ))}
          </SButtonGroup>
        )
      )}
    </SGridContainer>
  );
};
